import type { ReactNode } from 'react';
import { AppHeader } from './AppHeader';
import { AppSidebar, type SidebarNavItem } from './AppSidebar';

type AppShellProps = {
  orgLabel: string;
  navItems: SidebarNavItem[];
  backLabel: string;
  backTo: string;
  title: string;
  breadcrumb: string;
  userInitials: string;
  userAvatarUrl?: string | null;
  headerRight?: ReactNode;
  children: ReactNode;
};

export function AppShell({
  orgLabel,
  navItems,
  backLabel,
  backTo,
  title,
  breadcrumb,
  userInitials,
  userAvatarUrl,
  headerRight,
  children,
}: AppShellProps) {
  return (
    <div className="flex min-h-screen bg-bg-canvas">
      <AppSidebar orgLabel={orgLabel} items={navItems} backLabel={backLabel} backTo={backTo} />
      <div className="flex min-h-0 min-w-0 flex-1 flex-col">
        <AppHeader
          title={title}
          breadcrumb={breadcrumb}
          userInitials={userInitials}
          userAvatarUrl={userAvatarUrl}
          right={headerRight}
        />
        <main className="flex-1 overflow-y-auto p-8">{children}</main>
      </div>
    </div>
  );
}
